var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.addQuestionTemplate === 'default')?_c('div',{staticClass:"mt-4"},[_c('div',{staticClass:"label-area mb-4",style:({
      color: _vm.textColor || '#000000',
    })},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")]),_vm._v(" "),_c('hr')]):_c('div',[_c('div',{staticClass:"mt-4"},[_c('div',{staticClass:"label-area mb-4",staticStyle:{"display":"flex","align-items":"center","justify-content":"center"},style:({
        color: _vm.textColor || '#000000',
      })},[_vm._v("\n      "+_vm._s(_vm.text)+"\n    ")]),_vm._v(" "),_c('hr')])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-da1a4ee4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/molecules/metrics/label-question/index.vue
// module id = null
// module chunks = 